import { IResponse } from "models";

export enum ActionType {
  DELETE_PATIENT = "action/DELETE_PATIENT",
  DELETE_PATIENT_SUCCESS = "action/DELETE_PATIENT_SUCCESS",
  DELETE_PATIENT_ERROR = "action/DELETE_PATIENT_ERROR",
  DELETE_PATIENT_RESET = "action/DELETE_PATIENT_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IDeletePatientPayload {
  user_ids?: any;
  patient_ids?: any;
}

export interface IDeletePatientResponse extends IResponse {
  result: any;
}
